// extracted by mini-css-extract-plugin
module.exports = {"text":"lhG42v"};